import $ from "jquery";
import BD_Question from "@bd-components/bd-question";

export class QuestionWordCloud extends BD_Question {
  constructor(...args) {
    super(...args);

    this.elms = {
      checkbox: ".wordCloud__input",
      submit: ".js-submit",
      questionCard: ".questionCard",
    };
  }

  getEvents() {
    const elms = this.elms;
    return [
      {
        event: "change",
        selector: elms.checkbox,
        handler: this.onSelectionChange.bind(this),
        isQuestionEvent: true,
      },
    ];
  }

  onSelectionChange() {
    // const $el = $(el);
    // @ts-ignore
    // const maxWord = this?.questionData?.meta_data?.maximum_word || 1;
    // @ts-ignore
    const minWord = this?.questionData?.meta_data?.minimum_word || 1;
    const checkedLength = $(this.elms.checkbox + ":checked").length;

    // if ($el.is(":checked") && checkedLength > maxWord) {
    //   e.preventDefault();
    //   e.stopPropagation();

    //   $el.prop("checked", false);
    //   return;
    // }

    const questionCardAction = $(this.elms.questionCard).find(
      ".questionCard__actions"
    );

    if (checkedLength >= minWord /* && checkedLength <= maxWord */) {
      questionCardAction.addClass("is-active");
    } else {
      questionCardAction.removeClass("is-active");
    }
  }

  getAnswer() {
    const answers = $(".wordCloud__input:checked")
      .map(function () {
        return $(this).val();
      })
      .get();
    return answers;
  }
}
